import TipTapDisplay from "@/components/TipTapDisplay/TipTapDisplay.vue";
import { defineComponent, computed } from "@vue/composition-api";
import { routeParamsBuilder } from "@/views/helpers";

export default defineComponent({
  name: "workOrderInstructions",
  components: {
    TipTapDisplay,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    const workOrderInstructions = computed(() => {
      return $store.getters.workOrderInstructions;
    });

    const routeParams = routeParamsBuilder();

    const workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    return {
      workOrderInstructions,
      workOrder,

      routeParams,
    };
  },
});
